<template>
  <b-modal 
    ref="modalEtiqueta" 
    id="modal-configuracao-etiqueta" 
    hide-header
    hide-footer
    body-class="p-0 overflow-hidden"
    content-class="border-0 shadow-lg"
    centered
    size="xl"
    @shown="onModalShown"
  >
    <!-- Cabeçalho Premium -->
    <div class="modal-header-premium p-3 d-flex align-items-center bg-dark" 
         style="background: linear-gradient(135deg, #ff9800 0%, #f57c00 100%) !important;">
      <div class="header-icon-wrapper mr-3 bg-white-10">
        <i class="fa fa-tag text-white"></i>
      </div>
      <div>
        <h5 class="mb-0 font-weight-bold text-white">Configuração de Etiquetas</h5>
        <small class="text-white opacity-75">Gerenciar etiquetas e linhas de impressão</small>
      </div>
      <b-button variant="link" class="ml-auto text-white p-0 opacity-75" @click="fechar()">
        <i class="fa fa-times fa-lg"></i>
      </b-button>
    </div>

    <!-- Corpo do Modal -->
    <div class="p-4" style="max-height: 75vh; overflow-y: auto;">
      
      <!-- Seção Etiquetas -->
      <div class="mb-4">
        <div class="d-flex justify-content-between align-items-center mb-3">
          <h6 class="mb-0"><i class="fa fa-print mr-2"></i>Etiquetas</h6>
          <b-button size="sm" variant="success" @click="novaEtiqueta()">
            <i class="fa fa-plus mr-1"></i> Nova Etiqueta
          </b-button>
        </div>

        <b-table
          :items="etiquetas"
          :fields="fieldsEtiqueta"
          striped
          hover
          small
          responsive
          :busy="loadingEtiquetas"
          show-empty
          empty-text="Nenhuma etiqueta cadastrada"
        >
          <template #table-busy>
            <div class="text-center my-2">
              <b-spinner class="align-middle"></b-spinner>
            </div>
          </template>

          <template #cell(actions)="row">
            <b-button-group size="sm">
              <b-button variant="primary" @click="editarEtiqueta(row.item)" title="Editar">
                <i class="fa fa-edit"></i>
              </b-button>
              <b-button variant="danger" @click="excluirEtiqueta(row.item)" title="Excluir">
                <i class="fa fa-trash"></i>
              </b-button>
              <b-button variant="info" @click="selecionarEtiqueta(row.item)" title="Ver Linhas">
                <i class="fa fa-list"></i>
              </b-button>
            </b-button-group>
          </template>
        </b-table>
      </div>

      <!-- Modal Formulário Etiqueta -->
      <b-modal
        ref="modalFormEtiqueta"
        :title="(etiquetaSelecionada.ID ? 'Editar' : 'Nova') + ' Etiqueta'"
        size="lg"
        hide-footer
      >
        <div class="p-2">
          
          <b-row>
            <b-col md="6">
              <b-form-group label="Descrição*" label-for="descricao">
                <b-form-input
                  v-model="etiquetaSelecionada.DESCRICAO"
                  maxlength="100"
                  required
                />
              </b-form-group>
            </b-col>
            <b-col md="3">
              <b-form-group label="Ponto" label-for="ponto">
                <b-form-select v-model="etiquetaSelecionada.PONTO">
                  <option value="0">0 - ABATE</option>
                  <option value="1">1 - EXPEDIÇÃO</option>
                  <option value="2">2 - SERRA</option>
                  <option value="3">3 - VENDA</option>
                  <option value="4">4 - FECHAMENTO ABATE</option>
                  <option value="5">5 - DESOSSA</option>
                  <option value="6">6 - INTERNA</option>
                  <option value="7">7 - SAÍDA PRODUÇÃO</option>
                </b-form-select>
              </b-form-group>
            </b-col>
            <b-col md="3">
              <b-form-group label="Modelo" label-for="modelo">
                <b-form-select v-model="etiquetaSelecionada.MODELO">
                  <option value="0">Nenhum</option>
                  <option value="1">Ppla</option>
                  <option value="2">Pplb</option>
                  <option value="3">ZPLII</option>
                  <option value="4">Epl2</option>
                  <option value="5">EscLabel</option>
                  <option value="6">TSPL</option>
                </b-form-select>
              </b-form-group>
            </b-col>
          </b-row>

          <b-row>
            <b-col md="4">
              <b-form-group label="Porta" label-for="porta">
                <b-form-input
                  v-model="etiquetaSelecionada.PORTA"
                  maxlength="100"
                  placeholder="COM1, USB, LPT1, etc."
                />
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group label="Impressora" label-for="impressora">
                <b-form-input
                  v-model="etiquetaSelecionada.IMPRESSORA"
                  maxlength="50"
                />
              </b-form-group>
            </b-col>
            <b-col md="2">
              <b-form-group label="DPI" label-for="dpi">
                <b-form-select v-model="etiquetaSelecionada.DPI">
                  <option value="0">203 DPI</option>
                  <option value="1">300 DPI</option>
                  <option value="2">600 DPI</option>
                </b-form-select>
              </b-form-group>
            </b-col>
            <b-col md="2">
              <b-form-group label="Temperatura" label-for="temperatura">
                <b-form-input
                  v-model="etiquetaSelecionada.TEMPERATURA"
                  maxlength="10"
                />
              </b-form-group>
            </b-col>
          </b-row>

          <b-row>
            <b-col md="2">
              <b-form-group label="Velocidade" label-for="velocidade">
                <b-form-input
                  v-model="etiquetaSelecionada.VELOCIDADE"
                  maxlength="10"
                />
              </b-form-group>
            </b-col>
            <b-col md="2">
              <b-form-group label="Avanço" label-for="avanco">
                <b-form-input
                  v-model="etiquetaSelecionada.AVANCO"
                  maxlength="10"
                />
              </b-form-group>
            </b-col>
            <b-col md="2">
              <b-form-group label="Margem Esq." label-for="margem">
                <b-form-input
                  v-model="etiquetaSelecionada.MARGEM_ESQUERDA"
                  maxlength="10"
                />
              </b-form-group>
            </b-col>
            <b-col md="2">
              <b-form-group label="BackFeed" label-for="backfeed">
                <b-form-select v-model="etiquetaSelecionada.BACKFEED">
                  <option value="0">None</option>
                  <option value="1">On</option>
                  <option value="2">Off</option>
                </b-form-select>
              </b-form-group>
            </b-col>
            <b-col md="2">
              <b-form-group label="Origem" label-for="origem">
                <b-form-select v-model="etiquetaSelecionada.ORIGEM">
                  <option value="0">None</option>
                  <option value="1">Top</option>
                  <option value="2">Bottom</option>
                </b-form-select>
              </b-form-group>
            </b-col>
            <b-col md="2">
              <b-form-group label="Página Código" label-for="pagina-codigo">
                <b-form-select v-model="etiquetaSelecionada.PAGINA_CODIGO">
                  <option value="0">None</option>
                  <option value="1">437</option>
                  <option value="2">850</option>
                  <option value="3">852</option>
                  <option value="4">860</option>
                  <option value="5">1250</option>
                  <option value="6">1252</option>
                </b-form-select>
              </b-form-group>
            </b-col>
          </b-row>

          <b-row>
            <b-col md="10">
              <b-form-group label="Arquivo Log" label-for="arquivo-log">
                <b-form-input
                  v-model="etiquetaSelecionada.ARQUIVO_LOG"
                  maxlength="150"
                />
              </b-form-group>
            </b-col>
            <b-col md="2">
              <b-form-group label="Log Produção" label-for="ativar-log">
                <b-form-select v-model="etiquetaSelecionada.ATIVAR_LOG_PRODUCAO">
                  <option value="0">Não</option>
                  <option value="1">Sim</option>
                </b-form-select>
              </b-form-group>
            </b-col>
          </b-row>

          <b-row>
            <b-col md="12">
              <b-form-checkbox
                v-model="etiquetaSelecionada.OP_LIMPAR_MEMORIA"
                value="1"
                unchecked-value="0"
              >
                Limpar Memória
              </b-form-checkbox>
            </b-col>
          </b-row>

          <div class="mt-3 text-right">
            <b-button variant="secondary" @click="fecharModalEtiqueta()" class="mr-2">
              Cancelar
            </b-button>
            <b-button variant="success" @click="salvarEtiqueta()">
              <i class="fa fa-save mr-1"></i> Salvar
            </b-button>
          </div>
        </div>
      </b-modal>

      <!-- Seção Linhas da Etiqueta -->
      <div v-if="etiquetaAtual" class="mt-4">
        <div class="d-flex justify-content-between align-items-center mb-3">
          <h6 class="mb-0"><i class="fa fa-list mr-2"></i>Linhas da Etiqueta: {{ etiquetaAtual.DESCRICAO }}</h6>
          <b-button size="sm" variant="success" @click="novaLinha()">
            <i class="fa fa-plus mr-1"></i> Nova Linha
          </b-button>
        </div>

        <b-table
          :items="linhas"
          :fields="fieldsLinha"
          striped
          hover
          small
          responsive
          :busy="loadingLinhas"
          show-empty
          empty-text="Nenhuma linha cadastrada"
        >
          <template #table-busy>
            <div class="text-center my-2">
              <b-spinner class="align-middle"></b-spinner>
            </div>
          </template>

          <template #cell(TIPO)="row">
            {{ getTipoLabel(row.item.TIPO) }}
          </template>

          <template #cell(DADO)="row">
            {{ getDadoLabel(row.item.DADO) }}
          </template>

          <template #cell(actions)="row">
            <b-button-group size="sm">
              <b-button variant="primary" @click="editarLinha(row.item)" title="Editar">
                <i class="fa fa-edit"></i>
              </b-button>
              <b-button variant="danger" @click="excluirLinha(row.item)" title="Excluir">
                <i class="fa fa-trash"></i>
              </b-button>
            </b-button-group>
          </template>
        </b-table>
      </div>

      <!-- Modal Formulário Linha -->
      <b-modal
        ref="modalFormLinha"
        :title="(linhaSelecionada.ID ? 'Editar' : 'Nova') + ' Linha'"
        size="xl"
        hide-footer
      >
        <div class="p-2">
          
          <b-row>
            <b-col md="4">
              <b-form-group label="Tipo de Dado" label-for="tipo-dado">
                <b-form-select v-model="linhaSelecionada.DADO" @change="onTipoDadoChange">
                  <option v-for="option in dadosOptionsOrdenadas" :key="option.value" :value="option.value">
                    {{ option.value }} - {{ option.label }}
                  </option>
                </b-form-select>
              </b-form-group>
            </b-col>
            <b-col md="2">
              <b-form-group label="Alinhamento" label-for="orientacao">
                <b-form-select v-model="linhaSelecionada.ORIENTACAO">
                  <option value="0">or0 (Normal)</option>
                  <option value="1">or270</option>
                  <option value="2">or180</option>
                  <option value="3">or90</option>
                </b-form-select>
              </b-form-group>
            </b-col>
            <b-col md="2">
              <b-form-group label="Linha (Vertical)" label-for="linha">
                <b-form-input v-model="linhaSelecionada.LINHA" maxlength="10"/>
              </b-form-group>
            </b-col>
            <b-col md="2">
              <b-form-group label="Coluna (Horizontal)" label-for="coluna">
                <b-form-input v-model="linhaSelecionada.COLUNA" maxlength="10"/>
              </b-form-group>
            </b-col>
            <b-col md="1">
              <b-form-group label="Largura (Use tb para QrCode)" label-for="largura">
                <b-form-input v-model.number="linhaSelecionada.LARGURA" type="number"/>
              </b-form-group>
            </b-col>
            <b-col md="1">
              <b-form-group label="Altura" label-for="altura">
                <b-form-input v-model.number="linhaSelecionada.ALTURA" type="number"/>
              </b-form-group>
            </b-col>
          </b-row>

          <b-row class="mb-3 align-items-end">
            <b-col md="7">
              <b-form-group label="Imagem (BMP ou PCX)" label-for="upload-imagem">
                <b-form-file
                  id="upload-imagem"
                  accept=".bmp,.pcx,image/bmp"
                  placeholder="Selecione arquivo BMP/PCX"
                  browse-text="Carregar"
                  @change="onUploadImagem"
                />
              </b-form-group>
            </b-col>
            <b-col md="3">
              <b-form-group label="Nome da Imagem" label-for="nome-imagem">
                <b-form-input v-model="linhaSelecionada.NOME_IMAGEM" maxlength="100"/>
              </b-form-group>
            </b-col>
            <b-col md="2">
              <b-form-group label="Multiplicador da Imagem" label-for="multImg">
                <b-form-input v-model.number="linhaSelecionada.MULTIPLICADOR_IMAGEM" type="number"/>
              </b-form-group>
            </b-col>
          </b-row>

          <b-row class="mb-3" v-if="imagemPreviewSrc">
            <b-col md="12">
              <div class="border rounded p-2">
                <div class="small font-weight-bold mb-2">Preview da Imagem (carregada do banco)</div>
                <img
                  :src="imagemPreviewSrc"
                  alt="Preview da imagem"
                  style="max-height: 180px; max-width: 100%; object-fit: contain;"
                />
              </div>
            </b-col>
          </b-row>

          <div class="border rounded p-2 mb-2">
            <div class="small font-weight-bold mb-2">Tipo de Dado para Texto</div>
            <b-row>
              <b-col md="6">
                <b-form-group label="Fonte (ex Impressora ZPLII: A..Z - outras (0..9), a única fonte de multiplicação é 0)">
                  <b-form-input v-model="linhaSelecionada.FONTE" maxlength="10"/>
                </b-form-group>
              </b-col>
              <b-col md="3">
                <b-form-group label="Multiplicador H (ex:10) - Altura do Texto">
                  <b-form-input v-model="linhaSelecionada.MULTIPLICADORH" maxlength="10"/>
                </b-form-group>
              </b-col>
              <b-col md="3">
                <b-form-group label="Multiplicador V (ex:10) - Largura do Texto">
                  <b-form-input v-model="linhaSelecionada.MULTIPLICADORV" maxlength="10"/>
                </b-form-group>
              </b-col>
            </b-row>
          </div>

          <!-- Campos específicos para Código de Barras -->
          <div class="border rounded p-2 mb-2" v-if="linhaSelecionada.TIPO === 'C'">
            <div class="small font-weight-bold mb-2">Tipo de Dado - Código de Barras</div>
            <b-row>
              <b-col md="3">
                <b-form-group label="Tipo de Barras" label-for="codigo-barra">
                  <b-form-select v-model="linhaSelecionada.CODIGO_BARRA">
                    <option value="0">EAN13</option>
                    <option value="1">EAN8</option>
                    <option value="2">CODE128</option>
                    <option value="3">CODE39</option>
                    <!-- Adicionar mais conforme necessário -->
                  </b-form-select>
                </b-form-group>
              </b-col>
              <b-col md="2">
                <b-form-group label="Altura Barras" label-for="altura-barras">
                  <b-form-input v-model.number="linhaSelecionada.ALTURA_BARRAS" type="number"/>
                </b-form-group>
              </b-col>
              <b-col md="2">
                <b-form-group label="Exibir Código" label-for="exibe-codigo">
                  <b-form-select v-model="linhaSelecionada.EXIBE_CODIGO_BARRAS">
                    <option value="0">Padrão</option>
                    <option value="1">Sim</option>
                    <option value="2">Não</option>
                  </b-form-select>
                </b-form-group>
              </b-col>
              <b-col md="2">
                <b-form-group label="Larg. Barra Larga" label-for="larg-larga">
                  <b-form-input v-model.number="linhaSelecionada.LARGURA_BARRA_LARGA" type="number"/>
                </b-form-group>
              </b-col>
              <b-col md="2">
                <b-form-group label="Larg. Barra Fina" label-for="larg-fina">
                  <b-form-input v-model.number="linhaSelecionada.LARGURA_BARRA_FINA" type="number"/>
                </b-form-group>
              </b-col>
            </b-row>
          </div>

          <div class="border rounded p-2 mb-2">
            <div class="small font-weight-bold mb-2">Tipo de Dado - Desenhar Caixa</div>
          <b-row>
            <b-col md="2">
              <b-form-group label="Largura Caixa" label-for="larg-caixa">
                <b-form-input v-model.number="linhaSelecionada.LARGURA_CAIXA" type="number"/>
              </b-form-group>
            </b-col>
            <b-col md="2">
              <b-form-group label="Altura Caixa" label-for="alt-caixa">
                <b-form-input v-model.number="linhaSelecionada.ALTURA_CAIXA" type="number"/>
              </b-form-group>
            </b-col>
            <b-col md="2">
              <b-form-group label="Esp. Vertical" label-for="esp-vert">
                <b-form-input v-model.number="linhaSelecionada.ESPESSURA_VERTICAL_CAIXA" type="number"/>
              </b-form-group>
            </b-col>
            <b-col md="2">
              <b-form-group label="Esp. Horizontal" label-for="esp-horiz">
                <b-form-input v-model.number="linhaSelecionada.ESPESSURA_HORIZONTAL_CAIXA" type="number"/>
              </b-form-group>
            </b-col>
          </b-row>
          </div>

          <b-form-group label="Texto do Dado" label-for="texto-dado">
            <b-form-input id="texto-dado" v-model="linhaSelecionada.TEXTO_DADO" maxlength="200"/>
          </b-form-group>

          <b-row>
            <b-col md="12">
              <b-form-checkbox
                v-model="linhaSelecionada.REVERSO"
                value="1"
                unchecked-value="0"
              >
                Reverso
              </b-form-checkbox>
            </b-col>
          </b-row>

          <div class="mt-3 text-right">
            <b-button variant="secondary" @click="fecharModalLinha()" class="mr-2">
              Cancelar
            </b-button>
            <b-button variant="success" @click="salvarLinha()">
              <i class="fa fa-save mr-1"></i> Salvar
            </b-button>
          </div>
        </div>
      </b-modal>

    </div>

    <!-- Rodapé Premium -->
    <div class="modal-footer-premium p-3 bg-light border-top d-flex justify-content-end">
      <b-button variant="soft-primary" pill class="px-4 font-weight-bold" @click="fechar()">
        FECHAR
      </b-button>
    </div>
  </b-modal>
</template>

<script>
export default {
  name: 'ModalConfiguracaoEtiqueta',
  data() {
    return {
      loadingEtiquetas: false,
      loadingLinhas: false,
      
      etiquetas: [],
      linhas: [],
      etiquetaAtual: null,
      
      etiquetaSelecionada: this.getEtiquetaVazia(),
      linhaSelecionada: this.getLinhaVazia(),
      
      fieldsEtiqueta: [
        { key: 'ID', label: 'ID', sortable: true, thStyle: { width: '60px' } },
        { key: 'DESCRICAO', label: 'Descrição', sortable: true },
        { key: 'MODELO', label: 'Modelo', sortable: true, thStyle: { width: '100px' } },
        { key: 'PORTA', label: 'Porta', sortable: true, thStyle: { width: '120px' } },
        { key: 'actions', label: 'Ações', thStyle: { width: '140px' } }
      ],
      
      fieldsLinha: [
        { key: 'ID', label: 'ID', sortable: true, thStyle: { width: '60px' } },
        { key: 'TIPO', label: 'Tipo', sortable: true, thStyle: { width: '100px' } },
        { key: 'DADO', label: 'Dado', sortable: true, thStyle: { width: '150px' } },
        { key: 'LINHA', label: 'Linha', sortable: true, thStyle: { width: '80px' } },
        { key: 'COLUNA', label: 'Coluna', sortable: true, thStyle: { width: '80px' } },
        { key: 'TEXTO_DADO', label: 'Texto', sortable: true },
        { key: 'actions', label: 'Ações', thStyle: { width: '120px' } }
      ],

      // Opções de combos baseadas no protótipo Delphi completo
      dadosOptions: {
        '1': 'Nome do Cliente',
        '2': 'Data Produção',
        '3': 'Data Validade',
        '4': 'Lote',
        '5': 'Sexo',
        '6': 'Peso',
        '0': 'Dado',
        '7': 'Nome Produto',
        '8': 'Data Saida - Venda - Expedição',
        '9': 'Número Controle Venda',
        '10': 'Desenhar Caixa',
        '11': 'Código de Barras',
        '12': 'Dianteiro Marca X',
        '13': 'Traseiro Marca X',
        '14': 'Meio da Carcaça Marca X',
        '15': 'Macho Marca X',
        '16': 'Fêmea Marca X',
        '17': 'Nome do Produto Beneficiado',
        '18': 'Numero da Etiqueta',
        '19': 'Peso Embalagem',
        '20': 'Carboidrato',
        '21': 'Quantidade Porção',
        '22': 'Valor Energético',
        '23': 'Proteina',
        '24': 'Gordura Total',
        '25': 'Gordura Saturada',
        '26': 'Gordura Trans',
        '27': 'Colesterol',
        '28': 'Fibra Alimentar',
        '29': 'Ferro',
        '30': 'Sódio',
        '31': 'Resfriamento',
        '32': 'Número da Caixa',
        '33': 'Registro Agência',
        '34': 'Nome do Produto Linha 2',
        '35': 'Tara Embalagem',
        '36': 'Contem Quantidade',
        '37': 'Peso Bruto',
        '38': 'Razao Social',
        '39': 'Fantasia',
        '40': 'CNPJ',
        '41': 'IE',
        '42': 'Contato',
        '43': 'Endereço',
        '44': 'Ponta Agulha',
        '45': 'Traseiro Serrote',
        '46': 'Nomo do Grupo do Produto',
        '47': 'Tara da Caixa',
        '48': 'Tara Total',
        '50': 'Desenhar Linha',
        '51': 'Imagem',
        '52': 'Mensagem Armazenamento',
        '53': 'Mensagem Conservacao',
        '54': 'Nome SubGrupo Produto',
        '55': 'Nome Resumido Produto',
        '56': 'Nome Resumido Cliente',
        '57': 'Codigo do Produto',
        '58': 'Carboidratos %',
        '59': 'Proteinas %',
        '60': 'Gorduras Trans %',
        '61': 'Gorduras Saturadas %',
        '62': 'Gorduras Totais %',
        '63': 'Colesterol %',
        '64': 'Fibra Alimentar %',
        '65': 'Ferro %',
        '66': 'Sodio %',
        '67': 'Quantidade Porcao %',
        '68': 'Valor Energetico %',
        '69': 'Informacao Nutricional',
        '70': 'Temperatura Minima',
        '71': 'Temperatura Maxima',
        '72': 'QrCode',
        '80': 'Carboidrato2',
        '81': 'Quantidade Porção2',
        '82': 'Valor Energético2',
        '84': 'Proteina2',
        '85': 'Gordura Total2',
        '86': 'Gordura Saturada2',
        '87': 'Gordura Trans2',
        '88': 'Colesterol2',
        '89': 'Fibra Alimentar2',
        '90': 'Ferro2',
        '91': 'Sódio2',
        '92': 'Carboidratos2 %',
        '93': 'Proteinas2 %',
        '94': 'Gorduras Trans2 %',
        '95': 'Gorduras Saturadas2 %',
        '96': 'Gorduras Totais2 %',
        '97': 'Colesterol2 %',
        '98': 'Fibra Alimentar2 %',
        '99': 'Ferro2 %',
        '100': 'Sodio2 %',
        '101': 'Quantidade Porcao2 %',
        '102': 'Valor Energetico2 %',
        '103': 'Informacao Nutricional2',
        '104': 'SIE',
        '105': 'Acucares Totais',
        '106': 'Acucares Totais %',
        '107': 'Acucares Totais2',
        '108': 'Acucares Totais2 %',
        '109': 'Acucares Adicionados',
        '110': 'Acucares Adicionados %',
        '111': 'Acucares Adicionados2',
        '112': 'Acucares Adicionados2 %'
      }
    }
  },
  computed: {
    dadosOptionsOrdenadas() {
      return Object.keys(this.dadosOptions)
        .map(value => ({
          value: value,
          label: this.dadosOptions[value]
        }))
        .sort((a, b) => parseInt(a.value) - parseInt(b.value))
    },
    imagemPreviewSrc() {
      if (!this.linhaSelecionada || !this.linhaSelecionada.IMAGEM) {
        return ''
      }

      const nomeImagem = (this.linhaSelecionada.NOME_IMAGEM || '').toLowerCase()
      const ehPcx = nomeImagem.endsWith('.pcx')
      const mimeType = ehPcx ? 'image/x-pcx' : 'image/bmp'
      return `data:${mimeType};base64,${this.linhaSelecionada.IMAGEM}`
    }
  },
  methods: {
    abrir() {
      this.$refs.modalEtiqueta.show()
    },
    fechar() {
      this.$refs.modalEtiqueta.hide()
    },
    onModalShown() {
      this.carregarEtiquetas()
    },

    getEtiquetaVazia() {
      return {
        ID: null,
        DESCRICAO: '',
        PONTO: '0',
        MODELO: '0',
        PORTA: '',
        DPI: '0',
        TEMPERATURA: '',
        OP_LIMPAR_MEMORIA: '0',
        AVANCO: '',
        IMPRESSORA: '',
        MARGEM_ESQUERDA: '',
        BACKFEED: '0',
        ORIGEM: '0',
        PAGINA_CODIGO: '0',
        ARQUIVO_LOG: '',
        ATIVAR_LOG_PRODUCAO: '0',
        VELOCIDADE: ''
      }
    },

    getLinhaVazia() {
      return {
        ID: null,
        FONTE: '',
        MULTIPLICADORH: '',
        MULTIPLICADORV: '',
        LINHA: '',
        COLUNA: '',
        DADO: '0',
        TEXTO_DADO: '',
        ETIQUETA_ID: null,
        ORIENTACAO: '0',
        TIPO: 'B',
        PATH_IMAGEM: '',
        CODIGO_BARRA: '0',
        ALTURA_BARRAS: 0,
        EXIBE_CODIGO_BARRAS: '0',
        LARGURA_BARRA_LARGA: 0,
        LARGURA_BARRA_FINA: 0,
        LARGURA_CAIXA: 0,
        ALTURA_CAIXA: 0,
        ESPESSURA_VERTICAL_CAIXA: 0,
        ESPESSURA_HORIZONTAL_CAIXA: 0,
        REVERSO: '0',
        LARGURA: 0,
        ALTURA: 0,
        IMAGEM: '',
        NOME_IMAGEM: '',
        MULTIPLICADOR_IMAGEM: 0
      }
    },

    async carregarEtiquetas() {
      try {
        this.loadingEtiquetas = true
        const { data } = await this.$http.get('/api/protected/etiqueta/listar')
        this.etiquetas = data || []
      } catch (err) {
        console.error('Erro ao carregar etiquetas:', err)
        this.$root.$bvToast.toast('Erro ao carregar etiquetas', {
          title: 'Erro',
          variant: 'danger',
          autoHideDelay: 5000
        })
      } finally {
        this.loadingEtiquetas = false
      }
    },

    async carregarLinhas(etiquetaId) {
      try {
        this.loadingLinhas = true
        const { data } = await this.$http.get(`/api/protected/etiquetalinha/getByEtiquetaId/${etiquetaId}`)
        this.linhas = data || []
      } catch (err) {
        console.error('Erro ao carregar linhas:', err)
        this.$root.$bvToast.toast('Erro ao carregar linhas', {
          title: 'Erro',
          variant: 'danger',
          autoHideDelay: 5000
        })
      } finally {
        this.loadingLinhas = false
      }
    },

    novaEtiqueta() {
      this.etiquetaSelecionada = this.getEtiquetaVazia()
      this.$refs.modalFormEtiqueta.show()
    },

    editarEtiqueta(item) {
      this.etiquetaSelecionada = { ...item }
      this.$refs.modalFormEtiqueta.show()
    },

    fecharModalEtiqueta() {
      this.$refs.modalFormEtiqueta.hide()
      this.etiquetaSelecionada = this.getEtiquetaVazia()
    },

    async salvarEtiqueta() {
      try {
        if (!this.etiquetaSelecionada.DESCRICAO) {
          this.$root.$bvToast.toast('Informe a descrição da etiqueta', {
            title: 'Atenção',
            variant: 'warning',
            autoHideDelay: 3000
          })
          return
        }

        const url = this.etiquetaSelecionada.ID 
          ? '/api/protected/etiqueta/update'
          : '/api/protected/etiqueta/post'

        await this.$http.post(url, this.etiquetaSelecionada)

        this.$root.$bvToast.toast('Etiqueta salva com sucesso!', {
          title: 'Sucesso',
          variant: 'success',
          autoHideDelay: 3000
        })

        this.fecharModalEtiqueta()
        await this.carregarEtiquetas()
      } catch (err) {
        console.error('Erro ao salvar etiqueta:', err)
        this.$root.$bvToast.toast(err.response?.data || 'Erro ao salvar etiqueta', {
          title: 'Erro',
          variant: 'danger',
          autoHideDelay: 5000
        })
      }
    },

    async excluirEtiqueta(item) {
      const confirmacao = await this.$bvModal.msgBoxConfirm(
        `Confirma a exclusão da etiqueta "${item.DESCRICAO}"?`,
        {
          title: 'Confirmação',
          okVariant: 'danger',
          okTitle: 'Sim, excluir',
          cancelTitle: 'Cancelar'
        }
      )

      if (!confirmacao) return

      try {
        await this.$http.delete(`/api/protected/etiqueta/delete/${item.ID}`)

        this.$root.$bvToast.toast('Etiqueta excluída com sucesso!', {
          title: 'Sucesso',
          variant: 'success',
          autoHideDelay: 3000
        })

        await this.carregarEtiquetas()

        if (this.etiquetaAtual && this.etiquetaAtual.ID === item.ID) {
          this.etiquetaAtual = null
          this.linhas = []
        }
      } catch (err) {
        console.error('Erro ao excluir etiqueta:', err)
        this.$root.$bvToast.toast(err.response?.data || 'Erro ao excluir etiqueta', {
          title: 'Erro',
          variant: 'danger',
          autoHideDelay: 5000
        })
      }
    },

    selecionarEtiqueta(item) {
      this.etiquetaAtual = item
      this.carregarLinhas(item.ID)
    },

    novaLinha() {
      if (!this.etiquetaAtual) {
        this.$root.$bvToast.toast('Selecione uma etiqueta primeiro', {
          title: 'Atenção',
          variant: 'warning',
          autoHideDelay: 3000
        })
        return
      }

      this.linhaSelecionada = this.getLinhaVazia()
      this.linhaSelecionada.ETIQUETA_ID = this.etiquetaAtual.ID
      this.onTipoDadoChange(this.linhaSelecionada.DADO)
      this.$refs.modalFormLinha.show()
    },

    editarLinha(item) {
      this.linhaSelecionada = { ...item }
      this.onTipoDadoChange(this.linhaSelecionada.DADO)
      this.$refs.modalFormLinha.show()
    },

    fecharModalLinha() {
      this.$refs.modalFormLinha.hide()
      this.linhaSelecionada = this.getLinhaVazia()
    },

    onTipoDadoChange(value) {
      const dado = String(value)
      if (dado === '51') {
        this.linhaSelecionada.TIPO = 'I'
        return
      }

      if (dado === '11' || dado === '72') {
        this.linhaSelecionada.TIPO = 'C'
        return
      }

      this.linhaSelecionada.TIPO = 'B'
    },

    onUploadImagem(event) {
      const file = event && event.target && event.target.files ? event.target.files[0] : null
      if (!file) return

      const nome = file.name || ''
      const extensao = nome.split('.').pop().toLowerCase()
      if (extensao !== 'bmp' && extensao !== 'pcx') {
        this.$root.$bvToast.toast('Selecione somente arquivos BMP ou PCX', {
          title: 'Atenção',
          variant: 'warning',
          autoHideDelay: 4000
        })
        return
      }

      const reader = new FileReader()
      reader.onload = () => {
        const resultado = reader.result || ''
        const partes = String(resultado).split(',')
        this.linhaSelecionada.IMAGEM = partes.length > 1 ? partes[1] : ''
        this.linhaSelecionada.NOME_IMAGEM = nome
        this.linhaSelecionada.PATH_IMAGEM = nome
        this.linhaSelecionada.TIPO = 'I'
      }
      reader.onerror = () => {
        this.$root.$bvToast.toast('Não foi possível ler a imagem selecionada', {
          title: 'Erro',
          variant: 'danger',
          autoHideDelay: 4000
        })
      }
      reader.readAsDataURL(file)
    },

    async salvarLinha() {
      try {
        if (!this.linhaSelecionada.ETIQUETA_ID) {
          this.$root.$bvToast.toast('Selecione uma etiqueta', {
            title: 'Atenção',
            variant: 'warning',
            autoHideDelay: 3000
          })
          return
        }

        const url = this.linhaSelecionada.ID 
          ? '/api/protected/etiquetalinha/update'
          : '/api/protected/etiquetalinha/post'

        await this.$http.post(url, this.linhaSelecionada)

        this.$root.$bvToast.toast('Linha salva com sucesso!', {
          title: 'Sucesso',
          variant: 'success',
          autoHideDelay: 3000
        })

        this.fecharModalLinha()
        await this.carregarLinhas(this.etiquetaAtual.ID)
      } catch (err) {
        console.error('Erro ao salvar linha:', err)
        this.$root.$bvToast.toast(err.response?.data || 'Erro ao salvar linha', {
          title: 'Erro',
          variant: 'danger',
          autoHideDelay: 5000
        })
      }
    },

    async excluirLinha(item) {
      const confirmacao = await this.$bvModal.msgBoxConfirm(
        'Confirma a exclusão desta linha?',
        {
          title: 'Confirmação',
          okVariant: 'danger',
          okTitle: 'Sim, excluir',
          cancelTitle: 'Cancelar'
        }
      )

      if (!confirmacao) return

      try {
        await this.$http.delete(`/api/protected/etiquetalinha/delete/${item.ID}`)

        this.$root.$bvToast.toast('Linha excluída com sucesso!', {
          title: 'Sucesso',
          variant: 'success',
          autoHideDelay: 3000
        })

        await this.carregarLinhas(this.etiquetaAtual.ID)
      } catch (err) {
        console.error('Erro ao excluir linha:', err)
        this.$root.$bvToast.toast(err.response?.data || 'Erro ao excluir linha', {
          title: 'Erro',
          variant: 'danger',
          autoHideDelay: 5000
        })
      }
    },

    getTipoLabel(tipo) {
      const tipos = {
        'B': 'Texto',
        'I': 'Imagem',
        'C': 'Código Barras'
      }
      return tipos[tipo] || tipo
    },

    getDadoLabel(dado) {
      return this.dadosOptions[dado] || dado
    }
  }
}
</script>

<style scoped>
.modal-header-premium {
  border-bottom: none;
}

.header-icon-wrapper {
  width: 45px;
  height: 45px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
  font-size: 1.5rem;
}

.bg-white-10 {
  background-color: rgba(255, 255, 255, 0.15) !important;
}

.opacity-75 {
  opacity: 0.75;
}
</style>



// WEBPACK FOOTER //
// src/modals/ModalConfiguracaoEtiqueta.vue